'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PersistentMediaPlayer = function (_Component) {
  (0, _inherits3.default)(PersistentMediaPlayer, _Component);

  function PersistentMediaPlayer(props) {
    (0, _classCallCheck3.default)(this, PersistentMediaPlayer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PersistentMediaPlayer.__proto__ || (0, _getPrototypeOf2.default)(PersistentMediaPlayer)).call(this, props));

    _this.setStickyPlayer = function () {
      var _this$state = _this.state,
          stickyOffset = _this$state.stickyOffset,
          isMobile = _this$state.isMobile;

      var scrollPosition = window.scrollY;
      var mediaPlayerOffset = _this.getMediaPlayerOffset();
      if (!stickyOffset || stickyOffset !== mediaPlayerOffset) {
        _this.setState({ stickyOffset: mediaPlayerOffset });
      }
      if (stickyOffset && scrollPosition > stickyOffset && !isMobile) {
        _this.setState({ stickyPlayerisActive: true });
      } else if (stickyOffset && scrollPosition < stickyOffset || isMobile) {
        _this.setState({ stickyPlayerisActive: false });
      }
    };

    _this.getMediaPlayerOffset = function () {
      var _this$props = _this.props,
          containerRef = _this$props.containerRef,
          stickyScrollOffset = _this$props.stickyScrollOffset;

      var docBody = document.body.getBoundingClientRect();
      var mediaPlayer = containerRef.getBoundingClientRect();
      return mediaPlayer.bottom - docBody.top - stickyScrollOffset;
    };

    _this.getPersistentMediaPlayerClasses = function (stickyPlayerisActive) {
      return (0, _classnames2.default)({
        'quiver-persistent-media': true,
        'quiver-persistent-media--sticky': stickyPlayerisActive
      });
    };

    _this.handleResize = function () {
      if (window.innerWidth >= 976) _this.setState({ isMobile: false });else if (window.innerWidth < 976 && !_this.state.isMobile) {
        _this.setState({
          isMobile: true,
          stickyPlayerisActive: false
        });
      }
    };

    _this.resizeListener = (0, _lodash.throttle)(_this.handleResize, 250);
    _this.scrollListener = (0, _lodash.throttle)(_this.setStickyPlayer, 250);

    _this.state = {
      isMobile: false,
      stickyOffset: null,
      stickyPlayerisActive: false
    };
    return _this;
  }

  (0, _createClass3.default)(PersistentMediaPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.resizeListener);
      window.addEventListener('scroll', this.scrollListener);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_, prevState) {
      var stickyToggleCallback = this.props.stickyToggleCallback;
      var stickyPlayerisActive = this.state.stickyPlayerisActive;

      if (stickyToggleCallback && stickyPlayerisActive !== prevState.stickyPlayerisActive) {
        stickyToggleCallback(stickyPlayerisActive);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeListener);
      window.removeEventListener('scroll', this.scrollListener);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var stickyPlayerisActive = this.state.stickyPlayerisActive;

      return _react2.default.createElement(
        'div',
        { className: 'quiver-persistent-container' },
        _react2.default.createElement(
          'div',
          { className: this.getPersistentMediaPlayerClasses(stickyPlayerisActive) },
          children
        )
      );
    }
  }]);
  return PersistentMediaPlayer;
}(_react.Component);

PersistentMediaPlayer.defaultProps = {
  stickyScrollOffset: 0,
  stickyToggleCallback: null
};
PersistentMediaPlayer.propTypes = {
  children: _propTypes2.default.node.isRequired,
  containerRef: _propTypes2.default.node.isRequired,
  stickyScrollOffset: _propTypes2.default.number,
  stickyToggleCallback: _propTypes2.default.func
};
exports.default = PersistentMediaPlayer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PersistentMediaPlayer/PersistentMediaPlayer.js
// module id = 627
// module chunks = 11